module.exports = __webpack_public_path__ + "img/manupdated.50d65ad1.png";